import { KeyboardEvent } from 'react';
import arrowUpIcon from '../../../../../Asset/svg/arrow-up.svg';
import RedesignImage from '../../components/RedesignImage';
import { useIAChatInputStyles } from './IAChatInput.styles';

type IAChatInputProps = {
  inputValue: string;
  onInputChange: (value: string) => void;
  onSendMessage: () => void;
  isLoading: boolean;
  disabled: boolean;
};

const IAChatInput = ({
  inputValue,
  onInputChange,
  onSendMessage,
  isLoading,
  disabled,
}: IAChatInputProps) => {
  const classes = useIAChatInputStyles();

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (inputValue.trim()) {
        onSendMessage();
      }
    }
  };

  return (
    <div className={classes.inputContainer}>
      <textarea
        className={classes.input}
        placeholder="Posez une question"
        value={inputValue}
        onChange={e => onInputChange(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        rows={1}
        aria-label="Posez une question"
      />
      <button
        type="button"
        className={classes.sendButton}
        onClick={onSendMessage}
        disabled={!inputValue.trim() || isLoading}
        aria-label="Envoyer">
        <RedesignImage src={arrowUpIcon} alt="" className={classes.sendIcon} />
      </button>
    </div>
  );
};

export default IAChatInput;
